exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".RecentActivity-1a78a833 .name-4ed8744b{margin-right:10px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;flex:1 1 0%}.RecentActivity-1a78a833 .name-4ed8744b a,.RecentActivity-1a78a833 .name-4ed8744b a:hover,.RecentActivity-1a78a833 .name-4ed8744b a:visited,.RecentActivity-1a78a833 .name-4ed8744b a:active,.RecentActivity-1a78a833 .name-4ed8744b a:focus{color:inherit;text-decoration:none}.RecentActivity-1a78a833 .action-61022c12{flex:0 0 auto;text-align:right}.SiteActivity-3d804078{width:100%;display:flex;margin-bottom:10px}.SiteActivity-3d804078:last-child{margin-bottom:0px}\n", ""]);

// Exports
exports.locals = {
	"RecentActivity": "RecentActivity-1a78a833",
	"name": "name-4ed8744b",
	"action": "action-61022c12",
	"SiteActivity": "SiteActivity-3d804078"
};